import React, { useMemo } from "react";
import { useLocation } from "react-router-dom";
import { Skeleton } from "antd";

import { StoryImage, StoryInfo } from "./components";
import { StoryWrapper } from "./storyFace.styles";
import { useStoryDataContext } from "contexts/StoryContext";
import { useIsMobile } from "hooks";
import { useStoriesDataContext } from "contexts/StoriesContext";
import { Typography } from "@atoms";

function StoryLoader() {
  const isMobile = useIsMobile(767);
  return (
    <>
      <StoryWrapper>
        <Skeleton.Node active style={{ width: isMobile ? "100%" : 320, height: 440 }} />
        <Skeleton.Node active style={{ width: isMobile ? "100%" : 360, height: 440 }} />
      </StoryWrapper>

      <Skeleton.Node active style={{width: "100%", height: 50, marginTop: 10}}/>
    </>
  );
}

function StoryPlaceholder() {
  return (
    <Typography as="h2" style={{textAlign: 'center'}}>
      Создайте свою первую историю
    </Typography>
  );
}

function StoryFace() {
  const location = useLocation();
  const {storyLoading, story} = useStoryDataContext();
  const {stories, storiesLoading} = useStoriesDataContext();

  const isMyStory = useMemo(() => location.pathname.startsWith("/my-stories"), [location.pathname]);
  const wholeStory = useMemo(() => isMyStory ? "my-stories" : "stories", [isMyStory]);

  if (!storiesLoading && stories.length === 0 && !story) return <StoryPlaceholder />;

  if (storyLoading) return <StoryLoader />;

  return (
    <StoryWrapper>
      <div className="story-image">
        <StoryImage />
      </div>
      <StoryInfo />
    </StoryWrapper>
  );
}

export default StoryFace;
